import { Link, Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { handleApiErrors } from '../../../api/apiErrorHandler';
import { apiUrl } from '../../../api/apiUrl';
import http from '../../../api/axios';
import { useAuth } from '../../../context/AuthContext';
import { ResetPasswordForm } from '../../../forms/ResetPassword/ResetPasswordForm';
import { Values } from '../../../forms/ResetPassword/ResetPasswordForm.types';
import logger from '../../../utils/logger';
import { useLoading } from '../../../context/loadingContext';

/**
 * A component for the reset password page
 */
export const ResetPasswordPage = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const { startLoading, stopLoading } = useLoading();
  /**
   * Handles reset password form submit.
   * Sends forgot password API request.
   * @param values form data
   */
  const [params] = useSearchParams();
  const token = params.get('token');

  /**
   * Handles registration form submit.
   * Sends registration API.
   * @param values form data
   */
  const handleSubmit = async (values: Values) => {
    try {
      startLoading();
      const response = await http.apiPost({
        url: apiUrl.RESET_PASSWORD,
        data: { ...values, token },
      });
      if (response?.status === 204) {
        stopLoading();
        navigate('/signin');
      }
      logger.i(response);
    } catch (err) {
      stopLoading();
      handleApiErrors(err);
    }
  };

  if (isAuthenticated) return <Navigate to="/dashboard" />;
  if (!token) return <Navigate to="/forgot-password" />;

  return (
    <div className="mx-auto min-h-full h-screen flex items-center justify-center max-w-md py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl w-full space-y-8">
        <div className="mb-10">
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Reset password</h2>
        </div>
        <p className="text-center text-sm text-gray-600">
          Enter your email for which you want to reset password and your new password.
        </p>
        <ResetPasswordForm onSubmit={handleSubmit} />
        <p className="text-center text-sm text-gray-600">
          <Link to="/signin" className="font-medium text-blue-600 hover:text-blue-500">
            Back to sign in.
          </Link>
        </p>
      </div>
    </div>
  );
};
